import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const PMSLocationsSecondaryViewStore = GenericFieldFactory("PMS_LOCATIONS_SECONDARY_VIEW", null);